<template>
  <div class="wrap">
    <van-nav-bar z-index="10" :fixed="true" placeholder :title="$t('修改登录密码')" left-arrow @click-left="onClickLeft" />
    <div class="wrap_cont">
      <div class="titles">
        {{ $t('输入你的新密码') }}
      </div>
      <van-field label-width="6.5rem" colon v-model="DataArr.newpass" :placeholder="$t('新密码')" />
      <van-field label-width="8rem" colon v-model="DataArr.ConfirmPassword" :placeholder="$t('确认密码')" />
    </div>
    <div class="button-confirm">
      <van-button size="normal" type="default" block @click="ButtomEvent()">{{
        $t('user.Button.Two')
      }}</van-button>
    </div>
  </div>
</template>

<script>
import { getNewPhone } from '@/utils/tools'
import Modelu from '@/utils/Module'
import { REQUEST_API } from '@/http/api' // 引入封装的axios
import {
  Row,
  Col,
  Icon,
  Cell,
  GridItem,
  Grid,
  NavBar,
  ActionSheet,
  Button,
  Image,
  NoticeBar,
  Field,
  Toast,
} from 'vant'

export default {
  name: 'portrait',
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [GridItem.name]: GridItem,
    [Grid.name]: Grid,
    [NavBar.name]: NavBar,
    [ActionSheet.name]: ActionSheet,
    [Button.name]: Button,
    [Image.name]: Image,
    [NoticeBar.name]: NoticeBar,
    [Field.name]: Field,
    [Toast.name]: Toast,
  },
  data() {
    return {
      isDisabled: false, // 验证码按钮
      userInfo: {},
      DataArr: {
        code: '112233',
        newpass: '',
        ConfirmPassword: ''
      },
      codeImg: '',
      GetCodeTime: 0,
      GetCodeInterval: null
    }
  },
  created() {
    // this.ButtomCode();
    this.getUserInfo();
  },
  methods: {
    // 返回上一个路由
    onClickLeft() {
      this.$router.go(-1)
    },
    // 获取验证码
    ButtomCode() {
      if (this.DataArr.Phone !== '') {
        if (!this.GetCodeTime) {
          this.GetCodeTime = 60;
          this.GetCodeInterval = setInterval(() => {
            this.GetCodeTime -= 1;
            if (this.GetCodeTime === 0) {
              clearInterval(this.GetCodeInterval);
            }
          }, 1000)
          let me = this
          // 获取验证码的请求
          let formdata = {
            // phone: this.DataArr.Phone,
            phone: getNewPhone(this.DataArr.Phone),
            type: 1,
            cmd: '100002',
            /**
             * TO DO
             * 后面新增的
             */
            channel: Modelu.signStrFunc(),
            xsend: Modelu.getXsend(),
          }
          this.$api.getSMS({ userphone: this.DataArr.Phone, must: 2 }, res => {
            this.$toast(this.$t('Hint.SendCodeSuccess'));
          }, err => {
            this.$toast(err)
          })
          // REQUEST_API(formdata).then((data) => {
          //   console.log(data)
          //   if (data.data.sc == 0) {
          //     /**
          //      * TO DO
          //      * 现在没有图形验证码了
          //      */
          //     this.codeImg = `data:image/jpg;base64,${data.data.notifyList[0].data.code}`
          //     me.isDisabled = true
          //     /**
          //      * TO DO
          //      * 下面的我没有动
          //      */
          //     let interval = window.setInterval(function () {
          //       me.DataArr.buttonName = me.DataArr.time
          //       --me.DataArr.time
          //       if (me.DataArr.time < 0) {
          //         me.DataArr.buttonName = me.$t(
          //           'My.PersonalInformation.Password.ButtonCode'
          //         )
          //         me.DataArr.time = 60
          //         me.isDisabled = false
          //         window.clearInterval(interval)
          //       }
          //     }, 1000)
          //   }
          // })
        }
      } else {
        Toast(this.$t('My.PersonalInformation.Password.verifyPhone'))
      }
    },
    // 提交的
    ButtomEvent() {
      if (
        this.DataArr.newpass != '' &&
        this.DataArr.ConfirmPassword
      ) {
        if (this.DataArr.newpass !== this.DataArr.ConfirmPassword) {
          Toast(this.$t('hint.passwordDiff'))
          return
        }
        this.$api.editPwd({
          newpass: this.DataArr.newpass,
          code: '112233'
        }, res => {
          res.msg && Toast(res.msg);
          setTimeout(() => {
            this.$router.replace({ name: 'login' })
          }, 800)
        }, err => {
          err.msg && Toast(err.msg)
        })
      } else {
        Toast(this.$t('密码确认提示'))
      }
    },
    getUserInfo() {
      Toast.loading({
        forbidClick: true,
        duration: 0,
      })
      this.$api.getUserInfo(res => {
        this.DataArr.Phone = res.userphone;
        Toast.clear();
      }, err => {
        Toast.clear();
        this.$toast(err);
      })
    }
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 100%;
  height: 100%;
  min-height: 100vh;
  overflow: hidden;
  max-width: 750px;

  .wrap_cont {
    background: #008f8e;
    padding: 16px;
    margin: 20px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 10px;

    .titles {
      color: #fff;
    }

    /deep/ .van-cell {
      height: calc(45rem / 16);
      line-height: calc(45rem / 16);
      padding: 0 calc(16rem / 16);
      border-radius: calc(5rem / 16);

      .van-field__body {
        input {
          color: #606266;
          font-size: calc(14rem / 16);
        }
      }
    }
  }

  .button-confirm {
    width: 100%;
    margin-top: 1.5625rem;

    >.text {
      color: red;
      width: 90%;
      margin: 0 auto;
      font-size: 0.75rem;
      margin-bottom: 1.5625rem;
    }

    .code-img {
      width: 90%;
      // height: calc(44rem / 16);
      height: calc(80rem / 16);
      margin: calc(15rem / 16) auto;
      display: flex;
    }

    .van-button {
      width: 90%;
      margin: 0 auto;
      border-radius: 0.5rem;
      background-color: #094ba0;
      color: #fff;
      border: none;
      // color: #ffffff;
    }

    .van-button::before {
      border: none;
    }
  }
}
</style>